/* eslint-disable max-lines-per-function */
define(['Cloud/ui/icons'], function (icons) {
    const { toNDigits } = require('lib/bytes');

    return function (app, _) {
        var foldings = {};

        var CURRENT_FOLDER;

        app.on('routeChangeEnd', function () {
            var folder = app.folder();

            CURRENT_FOLDER = folder ? folder.id : null;
        });

        var _isLinks = void 0;
        var _isHome = void 0;
        var _isSharedIncoming = void 0;
        var _isTrashBin = void 0;
        var _isSearch = void 0;
        var _tree = void 0;

        function _startNormalize() {
            _isLinks = app.isLinks() || app.isSharedLinks();
            _isHome = app.isHome();
            _isSharedIncoming = app.isSharedIncoming();
            _tree = _.tree();
            _isTrashBin = app.isTrashBin();
            _isSearch = app.isSearch();
        }
        function _endNormalize() {
            _isLinks = void 0;
            _isHome = void 0;
            _isSharedIncoming = void 0;
            _tree = void 0;
            _isTrashBin = void 0;
            _isSearch = void 0;
        }

        var _normalizePropertiesId = void 0;
        function normalizeProperties(item) {
            if (item) {
                if (_normalizePropertiesId === item.id) {
                    return item;
                }

                _normalizePropertiesId = item.id;

                var isFolder = item.isFolder;

                // DOWNLOAD
                var isSharedIncoming = _isSharedIncoming === void 0 ? app.isSharedIncoming() : _isSharedIncoming;
                item.download = !isSharedIncoming && !_isTrashBin;

                // SIZE
                if (item.__size === void 0 || item.__size !== item.size) {
                    // Не вызываем лишний раз bytes.toNDigits, если size не был изменён
                    var description = toNDigits(item.size || 0, 3);
                    item.sizeTitle = description.space + ' ' + description.units;
                    item.__size = item.size;
                }

                item.sizeTitle = item.sizeTitle || '';

                // HREF
                var href;
                if (!_isTrashBin && !_isSearch && item.storage !== 'attaches') {
                    if (isFolder) {
                        if (item.__normalizeProps === item.__normalizeUrls && item.href) {
                            href = item.href;
                        } else {
                            var isLinks = _isLinks === void 0 ? app.isLinks() || app.isSharedLinks() : _isLinks;
                            var isHome = _isHome === void 0 ? app.isHome() : _isHome;
                            var hrefParams, additionalParams;
                            if (isLinks) {
                                if (item.id === '/ ') {
                                    hrefParams = { id: '/' };
                                } else if (item.weblink) {
                                    hrefParams = { id: item.weblink, storage: 'public' };
                                } else {
                                    hrefParams = { id: item.id, storage: 'home' };
                                    additionalParams = { kind: item.isFolder ? 'folder' : 'file' };
                                }
                            } else if (!isHome && item.home) {
                                hrefParams = { id: item.home, storage: 'home' };
                            } else {
                                hrefParams = { id: item.id };
                            }
                            href = app.buildHref(hrefParams, additionalParams);
                        }
                    } else {
                        href = item.url.view;
                    }
                    item.href = href;
                }

                // Publishing STATUS
                var tree = _tree === void 0 ? _.tree() : _tree;
                var isShared = isFolder && tree.isShared(item.id);
                var isMounted = isFolder && tree.isMounted(item.id);
                item.isShared = isShared;
                item.isMounted = isMounted;
                item.publishingStatus = item.weblink ? 'active' : isMounted ? 'mounted' : isShared ? 'shared' : 'inactive';

                item.icon = icons.getItemIcon(item);

                const parentFolder = tree.get(tree.getParentId(item));
                item.isThisOrParentMounted =
                    isMounted || tree.isDomainFolder(item.id) || (parentFolder && parentFolder.isThisOrParentMounted);
                item.favoritesEnabled = !item.isThisOrParentMounted && !isFolder && (_isHome === void 0 ? app.isHome() : _isHome);

                // OTHERS
                item.__normalizeProps = item.__normalizeUrls;
            }

            _normalizePropertiesId = void 0;
            return item;
        }

        function normalizeItem(item) {
            return normalizeProperties(_.normalizeUrls(item));
        }

        function findMountedAncestor(item, tree) {
            tree = tree || _.tree();

            if (tree && item) {
                var parentItemId = item.parent;

                while (parentItemId) {
                    var parentItem = tree.get(parentItemId);

                    if (!parentItem) {
                        break;
                    }

                    if (tree.isMounted(parentItem)) {
                        return parentItem;
                    }

                    parentItemId = parentItem.parent;
                }
            }

            return null;
        }

        Object.assign(app, {
            // текущая папка

            currentFolder: function () {
                if (CURRENT_FOLDER) {
                    return app.get(CURRENT_FOLDER);
                } else {
                    return app.folder();
                }
            },

            // список всех загруженных папок
            foldersTree: function (sid, cid) {
                sid = sid || _.sid();
                cid = cid || _.cid();

                var breadcrumbs = _.tree(sid).ancestors(cid);

                var result = {
                    active: _.tree(sid).has(cid) ? _.tree(sid).folder(cid) : null,
                    group: _.tree(sid).get('/').name,
                    groupId: '/',
                    items: [],
                };

                var recursive = function (item, parentId) {
                    var subFolders = _.tree(sid).subFolders(parentId);

                    for (var i = 0, length = subFolders.length; i < length; i++) {
                        var leaf = subFolders[i];
                        var id = leaf.id;

                        var href = app.buildHref({ id: id, storage: sid });

                        var child = {
                            icon: 'ico_folder_user',
                            text: leaf.name,
                            id: id,
                            href: href,
                            items: [],
                        };

                        if (leaf.count && leaf.count.folders) {
                            var isOpen = foldings[id] || breadcrumbs.includes(id);
                            child.foldings = isOpen ? 'open' : 'close';
                        }

                        item.items.push(child);
                        recursive(child, id);
                    }
                };

                recursive(result, '/');

                return result;
            },

            isFolder: function (id, storage) {
                return _.tree(storage || '').isFolder(id);
            },

            isDomainFolder: function (id) {
                return _.tree().isDomainFolder(id);
            },

            isSharedFolder: function (id) {
                return _.tree().isShared(id);
            },

            isMountedFolder: function (id) {
                return _.tree().isMounted(id);
            },

            isMounted: function (id, storage) {
                var tree = _.tree(storage);

                if (!tree) {
                    return false;
                }

                var item = tree.get(id);

                if (!item) {
                    return false;
                }

                if (tree.isFolder(item) && tree.isMounted(item)) {
                    return true;
                }

                return Boolean(findMountedAncestor(item, tree));
            },

            isReadOnlyMountedOrShared: function (id, storage) {
                const tree = _.tree(storage);

                if (!tree) {
                    return false;
                }

                const item = tree.get(id);

                if (!item) {
                    return false;
                }

                const { is, folderId } = app.isMountedOrSharedFolder(item);

                return is && app.get(folderId).readonly;
            },

            isMountedOrSharedFolder: function (item) {
                let folderId = null;
                let isMounted = false;
                let isShared = false;
                let is = Array.some(app.foldersBreadcrumbs(void 0, _.tree().folder(item)), function (folder) {
                    folderId = folder.id;
                    isMounted = app.isMountedFolder(folderId) || app.isDomainFolder(folderId);
                    isShared = app.isSharedFolder(folderId);
                    return isMounted || isShared;
                });

                return {
                    is: is,
                    isMounted,
                    isShared,
                    folderId,
                };
            },

            isFile: function (id) {
                return _.tree().isFile(id);
            },

            isVirus: function (ids) {
                if (Array.isArray(ids)) {
                    return Array.some(ids, function (id) {
                        return app.isVirus(id);
                    });
                } else {
                    return _.tree().isVirus(ids);
                }
            },

            isNotVirus: function (id) {
                return _.tree().isNotVirus(id);
            },

            isVirusSkip: function (id) {
                return _.tree().isVirusSkip(id);
            },

            // текущая папка (объект)
            folder: function (id) {
                id = id || _.cid();

                return this.get(_.tree().folder(id));
            },

            // список подпапок и файлов в текущей папке
            folderItems: function (item, params) {
                params = params || {};
                var tree = _.tree();
                var currentId = item ? tree.getId(item) : _.cid();

                item = tree.get(currentId);

                if (!item) {
                    return {
                        active: [],
                        items: [],
                        rev: null,
                    };
                }

                var folder = tree.get(tree.folder(currentId));
                var sort = tree.getSort(folder);
                var result = {
                    active: tree.isFile(currentId) ? [currentId] : [],
                    rev:
                        folder.id +
                        '|' +
                        folder.rev +
                        '|' +
                        folder.localRev +
                        '|' +
                        sort.type +
                        '-' +
                        sort.order +
                        '|' +
                        params.from +
                        '|' +
                        params.to,
                };

                _startNormalize();

                result.items = tree.items(
                    currentId,
                    params.from,
                    params.to,
                    normalizeItem,
                    params.onlyFolders,
                    params.onlyFiles,
                    params.filter,
                    params.returnId
                );
                _endNormalize();

                return result;
            },

            // список папок вверх по дереву от текущей (включая и текущую папку)
            // для хлебных крошек
            foldersBreadcrumbs: function (items, fromItem) {
                items =
                    items ||
                    Array.filter(_.tree().ancestorsOrSelf(fromItem || _.cid()), function (id) {
                        return _.tree().isFolder(id);
                    });

                if (!app.available().root) {
                    items.shift();
                }

                return items.map(function (id) {
                    return {
                        text: _.tree().get(id).name,
                        id,
                        href: app.buildHref({ id }),
                    };
                });
            },

            folderItemsCount: function (item) {
                var tree = _.tree();

                var folder = tree.get(tree.folder(item || _.cid()));

                return tree.itemsCountInfo(folder);
            },
        });

        Object.assign(_, {
            normalizeItem: normalizeItem,

            normalizeProperties: normalizeProperties,
        });
    };
});
